module.exports = __webpack_public_path__ + "static/img/logo.ed86b857.png";